import { Outlet } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import Navigation from "./components/Navigation";
import DisclaimerBanner from "./components/DisclaimerBanner";
import Footer from "./components/Footer";

const queryClient = new QueryClient();

const RootLayout = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <DisclaimerBanner />
      <Navigation />
      <Outlet />
      <Footer />
    </TooltipProvider>
  </QueryClientProvider>
);

export default RootLayout;
